<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Ventas / Listado de Ventas</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Detalle de Ventas</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12 border-2">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <h4>
        <strong>DETALLE DE VENTA: #{{ venta.id }} - </strong>
        <span v-if="venta.tipo_pago_nombre == 'PAGO AL CONTADO'" style="color: #28a745">
          {{ venta.tipo_pago_nombre }}
        </span>
        <span v-else-if="venta.tipo_pago_nombre == 'PAGO AL CRÉDITO'" style="color: #dc3545">
          {{ venta.tipo_pago_nombre }}
        </span>
      </h4>
    </div>
    <div class="grid border-bottom-3" style="background-color: #f8f9fa; border-radius: 5px; border: 1px solid black">
      <div class="col-6">
        <!-- <p class="mb-0">
          <strong>SUCURSAL: </strong>
          <span>{{ venta }}</span>
        </p> -->
        <p class="mb-0">
          <strong>RAZ&Oacute;N SOCIAL: </strong>
          <span>{{ venta.razon_social }}</span>
        </p>
        <p class="mb-0">
          <strong>NIT/CI: </strong> <span>{{ venta.nit }}</span>
        </p>
        <p class="mb-0" v-if="venta.observacion">
          <strong>OBSERVACIONES: </strong>
          <span>{{ venta.observacion }}</span>
        </p>
        <!-- <p class="mb-0">
          <strong>NRO. FACTURA: </strong>
          <span>{{ venta.nrofactura }}</span>
        </p> -->
        <p v-if="tipo_negocio == 2">
          <!-- CardWash -->
          <strong>PLACA: </strong>
          <span>{{ venta['vehiculo'] ? venta['vehiculo']['placa'] : '-' }}</span>
        </p>
      </div>
      <div class="col-6">
        <p class="mb-0">
          <strong>FECHA VENTA: </strong>
          <span>{{ venta.fecha_venta }}</span>
        </p>
        <p class="mb-0" v-if="tipo_negocio == 2">
          <strong>REALIZADO POR: </strong>
          <span>{{ venta.nombre_medico ?? '-' }}</span>
        </p>
        <p class="mb-0">
          <strong>VENDEDOR: </strong>
          <span>{{ venta.nombre_usuario_caja }}</span>
        </p>
      </div>
    </div>
    <div class="grid mt-4">
      <DataTable
        ref="ventas"
        :value="productos"
        class="col-12 p-datatable-sm"
        showGridlines
        style="font-family: 'Roboto', sans-serif; font-weight: 400; line-height: 1.5"
      >
        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>
        <Column field="codigo_interno" header="COD. INTERNO">
          {{ producto.codigo_interno }}
        </Column>
        <Column field="pivot.cantidad" header="CANTIDAD" style="text-align: right">
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.cantidad) }}
          </template>
        </Column>
        <Column field="descripcion" header="PRODUCTO/SERVICIO" style="font-weight: bold">
          <template #body="slotProps">
            <div>
              <span>{{ slotProps.data.descripcion }}</span>
              <span
                class="ml-2"
                v-if="slotProps.data.pivot.nombre_medico"
                style="font-size: 11px; background-color: #e0e0e0; padding: 2px; border-radius: 3px"
                v-tooltip.top="`Trabajador: ${slotProps.data.pivot.nombre_medico}`"
              >
                <i class="pi pi-user" style="color: #2196f3"></i>
                {{ slotProps.data.pivot.nombre_medico }}
              </span>
            </div>
          </template>
        </Column>
        <Column header="TALLA" class="text-center">
          <template #body="{ data }">
            <span v-if="data.tipo_catalogo === 1"><strong>{{ data.pivot.talla_nombre || 'Única' }}</strong></span>
            <span v-else>-</span>
          </template>
        </Column>
        <Column header="COLOR" class="text-center">
          <template #body="{ data }">
            <span v-if="data.tipo_catalogo === 1">
              <strong>{{ data.pivot.color_nombre || 'Único' }}</strong>
            </span>
            <span v-else>-</span>
          </template>
        </Column>
        <Column field="pivot.precio" header="PRECIO UNIT." style="text-align: right">
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.precio) }}
          </template>
        </Column>
        <Column field="pivot.descuento_neto" header="DESCUENTO" style="text-align: right">
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.descuento_neto ?? 0) }}
          </template>
        </Column>
        <Column header="SUBTOTAL" style="text-align: right">
          <template #body="slotProps">
            {{
              convertirNumeroGermanicFormat(
                slotProps.data.pivot.cantidad * slotProps.data.pivot.precio - slotProps.data.pivot.descuento_neto
              )
            }}
          </template>
        </Column>
        <template #footer>
          <div class="text-lg flex align-items-end justify-content-end">
            <span
              >SUBTOTAL:
              {{ convertirNumeroGermanicFormat(subtotal) }}
            </span>
          </div>
          <div class="text-lg flex align-items-end justify-content-end">
            <span>DESC.: {{ convertirNumeroGermanicFormat(venta.descuento) }}</span>
          </div>
          <div
            class="flex align-items-end justify-content-end"
            v-if="venta.total_venta_qr > 0 || venta.total_venta_tarjeta > 0"
          >
            <span class="metodos-pago">
              <strong>EFECTIVO:</strong>
              {{ convertirNumeroGermanicFormat(venta.efectivo) }}
            </span>
            <br />
          </div>
          <div class="flex align-items-end justify-content-end" v-if="venta.total_venta_qr > 0">
            <span class="metodos-pago">
              <strong>QR:</strong>
              {{ convertirNumeroGermanicFormat(venta.total_venta_qr) }}
            </span>
          </div>
          <div class="flex align-items-end justify-content-end" v-if="venta.total_venta_tarjeta > 0">
            <span class="metodos-pago">
              <strong>TARJETA:</strong>
              {{ convertirNumeroGermanicFormat(venta.total_venta_tarjeta) }}
            </span>
          </div>
          <div v-if="venta.tipo_pago_id != 1" class="text-lg flex align-items-end justify-content-end">
            <span
              >A CUENTA:
              {{ convertirNumeroGermanicFormat(venta.total_pagos) }}
            </span>
          </div>
          <div v-if="venta.tipo_pago_id != 1" class="text-lg flex align-items-end justify-content-end">
            <span
              >RECARGO:
              {{ convertirNumeroGermanicFormat(venta.monto_interes_total) }}
            </span>
          </div>
          <div class="text-lg flex align-items-end justify-content-end">
            <span
              >MONTO {{ venta.tipo_pago_id == 1 ? 'CANCELAR' : 'DEBE' }} Bs :
              {{
                convertirNumeroGermanicFormat(
                  venta.tipo_pago_id == 1 ? venta.total_cancelar : venta.total_cancelar - venta.total_pagos
                )
              }}
            </span>
          </div>
          <div v-if="venta.tipo_pago_id != 1" class="text-lg flex align-items-end justify-content-end">
            <span
              >TOTAL VENTA:
              {{ convertirNumeroGermanicFormat(venta.total_venta_interes) }}
            </span>
          </div>
        </template>
      </DataTable>
    </div>
    <div class="grid mt-2 justify-content-end">
      <Button @click="goBack" class="p-button-primary p-button-lg" v-tooltip.top="'Volver a Ventas'">
        <i class="pi pi-arrow-left"></i>&nbsp;ATR&Aacute;S
      </Button>
      <Button
        v-if="printerName"
        label="IMPRIMIR"
        icon="pi pi-print"
        class="p-button-lg p-button-warning ml-2"
        v-tooltip.top="'Imprimir Venta Directo'"
        @click="imprimirDirecto(venta.id)"
        :loading="imprimiendoDirecto"
      ></Button>
      <!-- boton para crear factura -->
      <Button
        v-if="'Venta Facturar' in auth.user.permissions && venta.facturado == 0"
        label="CREAR FACTURA"
        icon="pi pi-book"
        class="p-button-secondary ml-2"
        v-tooltip.top="'Crear Factura'"
        @click="ventaFacturar(venta)"
      >
      </Button>
      <!-- Verificar Estado de Factura -->
      <Button
        v-if="'Venta Facturar' in auth.user.permissions && venta.facturado == 1"
        icon="pi pi-check-circle"
        class="p-button-danger ml-2"
        v-tooltip.top="'Verificar Estado de Factura'"
        @click="verificarEstado({ venta_id: venta.id })"
      >
      </Button>
      <Button
        :label="venta.facturado == 1 ? 'IMPRIMIR FACTURA' : 'DESCARGAR PDF'"
        icon="pi pi-file-pdf"
        class="p-button-lg p-button-danger ml-2"
        v-tooltip.top="'Imprimir PDF'"
        @click="imprimirVenta(venta.id)"
        :disabled="imprimiendo"
        :loading="imprimiendo"
      >
      </Button>
      <Button
        v-show="false"
        :label="enviando_whatsapp ? 'ENVIANDO...' : 'ENVIAR'"
        icon="pi pi-whatsapp"
        class="p-button-lg p-button-success ml-2"
        v-tooltip.top="'Enviar por WhatsApp'"
        @click="enviarWhatsApp(venta)"
        :disabled="enviando_whatsapp"
      >
      </Button>
    </div>
  </div>
  <!-- Modal VentaFacturar -->
  <VentaFacturar
    v-if="ventafacturaDialog"
    :show="ventafacturaDialog"
    :ventaFactura="ventaFactura"
    @closeModal="ocultarDialog"
    @actualizarListado="cargarVenta"
  />

  <!-- Modal Verificar Estado -->
  <FacturaEstadoVerificacion
    v-if="modalVerificarEstado"
    v-model:visible="modalVerificarEstado"
    :datos="datosVerificacion"
    :loading="verificandoEstado"
    @closed="limpiarDatosVerificacion"
  />
</template>

<script>
import VentaService from '@/service/VentaService'
import { useAuth } from '@/stores'
import VentaFacturar from '@/module/ventas/VentaFacturar.vue'
import FacturaEstadoVerificacion from '@/module/facturas/FacturaEstadoVerificacion.vue'

export default {
  components: {
    VentaFacturar,
    FacturaEstadoVerificacion
  },
  data() {
    return {
      venta: {},
      venta_id: this.$route.params.id,
      productos: [],
      imprimiendo: false,
      enviando_whatsapp: false,
      tipo_negocio: null,
      imprimiendoDirecto: false,
      printerName: '',
      ventaFactura: {},
      ventafacturaDialog: false,
      // Variables para verificación de factura
      modalVerificarEstado: false,
      datosVerificacion: {},
      verificandoEstado: false
    }
  },
  ventaService: null,
  auth: null,

  created() {
    this.ventaService = new VentaService()
    this.auth = useAuth()
  },
  mounted() {
    this.cargarVenta()
  },
  computed: {
    subtotal() {
      let subtotal = 0
      this.productos.forEach((producto) => {
        subtotal += producto.pivot.precio * producto.pivot.cantidad
      })
      return subtotal
    }
  },
  methods: {
    verificarEstado(datos) {
      this.modalVerificarEstado = true
      this.verificandoEstado = true

      this.ventaService
        .verificarEstadoFactura(datos.venta_id)
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: response.mensaje,
              life: 3000
            })

            // Mapeo correcto según la estructura de tu API
            this.datosVerificacion = {
              venta_id: datos.venta_id,
              cuf: response.cuf, // CUF viene directo de response
              estado: response.estado, // Estado viene directo de response
              mensaje: response.mensaje,
              detalles: {
                success: response.detalles?.success,
                invoice: {
                  number: response.detalles?.invoice?.number,
                  total: response.detalles?.invoice?.total, // ⭐ Total aquí
                  createdAt: response.detalles?.invoice?.createdAt, // ⭐ Fecha aquí
                  cuf: response.detalles?.invoice?.cuf,
                  statusCode: response.detalles?.invoice?.statusCode
                },
                siatResponse: {
                  codigoDescripcion: response.detalles?.siatResponse?.codigoDescripcion,
                  codigoEstado: response.detalles?.siatResponse?.codigoEstado, // ⭐ Código estado aquí
                  transaccion: response.detalles?.siatResponse?.transaccion,
                  codigoRecepcion: response.detalles?.siatResponse?.codigoRecepcion // ⭐ Código recepción aquí
                }
              }
            }
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: response.mensaje,
              life: 3000
            })
            this.modalVerificarEstado = false
          }
        })
        .catch((error) => {
          this.modalVerificarEstado = false
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo verificar el estado: ' + (error.message || ''),
            life: 3000
          })
        })
        .finally(() => {
          this.verificandoEstado = false
        })
    },

    // Limpia los datos cuando se cierra el modal
    limpiarDatosVerificacion() {
      this.datosVerificacion = {}
    },

    ventaFacturar(venta) {
      this.ventaFactura = {
        ...venta,
        nit: venta.nit && venta.nit !== '0' && venta.nit !== '99001' ? Number(venta.nit) : null
      }
      this.ventafacturaDialog = true
    },
    ocultarDialog() {
      this.ventafacturaDialog = false
      this.ventaFactura = {} // Limpiar datos
    },
    imprimirDirecto(id) {
      if (this.imprimiendoDirecto) return

      this.imprimiendoDirecto = true

      this.ventaService
        .imprimirDirecto(id, this.printerName)
        .then(() => {})
        .catch((error) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: error.message || 'No se pudo imprimir.',
            life: 4000
          })
        })
        .finally(() => {
          this.imprimiendoDirecto = false
        })
    },
    enviarWhatsApp(datos) {
      this.enviando_whatsapp = true
      this.ventaService
        .enviarWhatsApp(datos)
        .then((datos) => {
          if (datos.status == 400) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: datos.message,
              life: 3000
            })
            this.enviando_whatsapp = false
          } else {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: datos.message,
              life: 3000
            })
            this.enviando_whatsapp = false
          }
        })
        .catch((error) => console.log(error))
    },
    imprimirVenta(id) {
      if (this.imprimiendo) {
        return
      }
      this.imprimiendo = true
      this.ventaService.imprimirVenta(id).then(() => {
        this.imprimiendo = false
      })
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2
      }).format(numero)
    },
    cargarVenta() {
      this.ventaService.getVenta(this.venta_id).then((response) => {
        this.venta = response.venta
        this.tipo_negocio = response.tipo_negocio
        this.productos = this.venta.productos
        this.printerName = response.printerName || ''
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.metodos-pago {
  border: 1px solid #d0d0d0;
}
</style>
